import { Container } from "@chakra-ui/react";
import { ReactNode } from "react";
import { LuExternalLink } from "react-icons/lu"

type Props = {
    title: string;
    children: ReactNode;
    color?: 'blue' | 'teal' | 'purple' | 'brick' | 'slate' | 'olive';
}

type BodyProps = {
    children: ReactNode;
}

type FooterProps = {
    children: ReactNode;
}

const ProjectCard95Base = (props: Props) => {
    let bodyContent: ReactNode = null;
    let footerContent: ReactNode = null;

    const childrenArray = Array.isArray(props.children) ? props.children : [props.children];
    
    childrenArray.forEach((child: any) => {
        if (child?.type === ProjectCard95.Body) {
            bodyContent = child.props.children;
        } else if (child?.type === ProjectCard95.Footer) {
            footerContent = child.props.children;
        }
    });

    const colorClass = props.color ? `win95-title-bar-${props.color}` : 'win95-title-bar-blue';

    return (
        <div className="win95-window" style={{ width: "280px", height: "300px" }}>
            <div className={`win95-title-bar ${colorClass}`}>
                <div className="win95-title-text">
                    {props.title}
                </div>
                <div className="win95-title-buttons">
                    <button className="win95-title-button" aria-hidden>X</button>
                </div>
            </div>
            <div className="win95-window-body">
                <div>
                    <h2 style={{ fontSize: '20px', margin: '0 0 8px 0' }}>
                        {props.title}
                    </h2>
                    {bodyContent}
                </div>
                {footerContent}
            </div>
        </div>
    );
}

const ProjectCard95Body = (props: BodyProps) => {
    return <>{props.children}</>;
}

const ProjectCard95Footer = (props: FooterProps) => {
    return <>{props.children}</>;
}

export const ProjectCard95 = Object.assign(ProjectCard95Base, {
    Body: ProjectCard95Body,
    Footer: ProjectCard95Footer
});

export const ProjectButton95 = (props: { title: string, external?: boolean }) => {
    return (
        <Container mt={4} justifyContent="center" display="flex">
            <button type="button" className="win95-button" style={{ display: "inline-block" }}>
                {props.title}
                {props.external ? <LuExternalLink style={{ display: "inline-block", marginLeft: "4px", position: "relative", top: "1px" }} /> : null}
            </button>
        </Container>
    );
}